import apiService from '../apiService';

export const addTagTypes = ['Plans_List'] as const;

export const applicationsApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getPlansList: build.query({
				query: () => ({
					url: `plan`
				}),
				providesTags: ['Plans_List']
			}),
			checkoutPlan: build.mutation({
				query: (id) => ({
					url: `subscription/checkout`,
					method: 'POST',
					body: { plan_id: id }
				}),
				invalidatesTags: ['Plans_List']
			}),
			checkSessionStatus: build.mutation({
				query: (body: { session_id: string; address_id?: number }) => ({
					url: 'plan/checkSessionStatus',
					method: 'POST',
					body
				})
			}),
			upgradePlan: build.mutation({
				query: ({ id }) => ({
					url: 'plan/upgrade',
					method: 'POST',
					body: {
						new_plan_id: id
					}
				})
			})
		})
	});

export const {
	useGetPlansListQuery,
	useCheckSessionStatusMutation,
	useCheckoutPlanMutation,
	useUpgradePlanMutation,
} = applicationsApi;

export type PlanObject = {
	id: number;
	amount: number;
	price_id: string;
	currency: string;
	interval: string;
	nickname: string;
	number_of_applications: number;
	isCurrentPlan: boolean;
	isUpgradeable: boolean;
};
